
import React from 'react';
import { Box, Button, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { Dashboard as DashboardIcon, Home as HomeIcon, Inventory as InventoryIcon, Build as BuildIcon, Storefront as StorefrontIcon, ReceiptLong as ReceiptLongIcon, RequestQuote as InvoiceIcon, Print as PrintIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { isStaffUser } from './MadebbProtectedRoute';

interface MadebbLayoutProps {
  children: React.ReactNode;
  title: string;
}

export const MadebbLayout: React.FC<MadebbLayoutProps> = ({ children, title }) => {
  const { signOut, user } = useAuth();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch {
      // ignore
    } finally {
      navigate('/madebb/login');
    }
  };

  return (
    <Box sx={{ p: 3, minHeight: '100vh', bgcolor: 'grey.50' }}>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
        <Typography variant="h5" fontWeight={700}>
          {title}
        </Typography>
        <Stack direction="row" spacing={1} alignItems="center">
          <Tooltip title="Dashboard">
            <IconButton onClick={() => navigate('/madebb/dashboard')} size="small" data-testid="home-nav">
              <HomeIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Roll Shade Calculator">
            <IconButton onClick={() => navigate('/madebb/roll-shade-order')} size="small" data-testid="calculator-nav">
              <DashboardIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Production">
            <IconButton onClick={() => navigate('/madebb/manufacturing')} size="small">
              <BuildIcon />
            </IconButton>
          </Tooltip>
           <Tooltip title="Inventory">
            <IconButton onClick={() => navigate('/madebb/inventory')} size="small">
              <InventoryIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Shop Admin">
            <IconButton
              onClick={() => navigate('/madebb/shop-admin')}
              size="small"
              data-testid="shop-admin-nav"
            >
              <StorefrontIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Printers">
            <IconButton
              onClick={() => navigate('/madebb/printers')}
              size="small"
              data-testid="printers-nav"
            >
              <PrintIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="eReceipts">
            <IconButton
              onClick={() => navigate('/madebb/shop-admin/ereceipts')}
              size="small"
              data-testid="ereceipts-nav"
            >
              <ReceiptLongIcon />
            </IconButton>
          </Tooltip>
          {isStaffUser(user?.email) && <Tooltip title="Invoices">
            <IconButton onClick={() => navigate('/madebb/invoices')} size="small" aria-label="Invoices" data-testid="invoices-nav">
              <InvoiceIcon />
            </IconButton>
          </Tooltip>}
          <Button variant="outlined" size="small" color="inherit" onClick={handleSignOut}>
            Sign out
          </Button>
        </Stack>
      </Stack>
      <Box>
        {children}
      </Box>
    </Box>
  );
};
